import { createSelector } from 'reselect';
import { defaultSettings, mainItemTypeValues, layoutStyleValues } from 'widget/player-widget';


export function getAllSettings(state) {
  return state.appSettings;
}

export function getNumberOfRows(state) {
  return _.get(state, 'appSettings.numbers.numberOfRows', defaultSettings.numbers.numberOfRows);
}

export function getVideosInRowCount(state) {
  return _.get(state, 'appSettings.numbers.videosInRow', defaultSettings.numbers.videosInRow);
}

export function getVideoInfoPosition(state) {
  return _.get(state, 'appSettings.numbers.videoInfoPosition', defaultSettings.numbers.videoInfoPosition);
}

export function getInfoActionVisibility(state) {
  return _.get(state, 'appSettings.numbers.showInfoAction', defaultSettings.numbers.showInfoAction);
}

export function getLayoutStyle(state) {
  return _.get(state, 'appSettings.numbers.layoutStyle', defaultSettings.numbers.layoutStyle);
}

export function getSiteUrl(state) {
  return state.appSettings.siteUrl;
}

export function getInstance(state) {
  return state.appSettings.instance;
}

export function getChannelLayout(state) {
  return _.get(state, 'appSettings.numbers.channelLayout', defaultSettings.numbers.channelLayout);
}

export function canShowChannelInfo(state) {
  return _.get(state, 'appSettings.booleans.showChannelInfo', defaultSettings.booleans.showChannelInfo);
}

export function canShowSearch(state) {
  return _.get(state, 'appSettings.booleans.showSearch', defaultSettings.booleans.showSearch);
}

export function canShowMainItemTitle(state) {
  return _.get(state, 'appSettings.booleans.showTitleForMainItem', defaultSettings.booleans.showTitleForMainItem);
}

export function canShowMainItemPublisher(state) {
  return _.get(state, 'appSettings.booleans.showPublisherForMainItem', defaultSettings.booleans.showPublisherForMainItem);
}

export function isPreviewHover(state) {
  return _.get(state, 'appSettings.booleans.previewHover', false);
}

export function canShowVideoListItemPublisher(state) {
  return _.get(state, 'appSettings.booleans.showVideoPublisherInList', defaultSettings.booleans.showVideoPublisherInList);
}

export function canShowVideoListItemTitle(state) {
  return _.get(state, 'appSettings.booleans.showVideoTitleInList', defaultSettings.booleans.showVideoTitleInList);
}

export const canShowChannelTags = createSelector(
  [
    canShowSearch,
    state => _.get(state, 'appSettings.booleans.showChannelTags', defaultSettings.booleans.showChannelTags),
  ],
  (canShowSearch, canShowTags) => canShowSearch && canShowTags,
);

export function getMainItemType(state) {
  return _.get(state, 'appSettings.numbers.mainItemType', defaultSettings.numbers.mainItemType);
}

export const isMainItemFeaturedVideo = createSelector(
  [
    getMainItemType,
  ],
  mainItemType => mainItemType === mainItemTypeValues.FEATURED_VIDEO,
);

export const areElementsRounded = createSelector(
  [
    getLayoutStyle,
  ],
  layoutStyle => layoutStyle === layoutStyleValues.ROUND,
);



// WEBPACK FOOTER //
// ./src/shared/selectors/app-settings.js